import { useFeatureIsOn } from '@model/ab-testing/service/ab-testing-api';
import { GrowthBookFeatures } from '@model/ab-testing/features';

export const useFiltersLayout = () => {
  const filtersLeftFeature: string = GrowthBookFeatures.FILTERS_LEFT;
  const filtersLeftFeatureEnabled = useFeatureIsOn(filtersLeftFeature);

  return {
    filtersPosition: filtersLeftFeatureEnabled ? 'left' : ('right' as const),
    filtersLeftFeatureEnabled
  };
};
